import { render, staticRenderFns } from "./TenantSubscriptionExtendPeriodDialog.vue?vue&type=template&id=286962fe&"
import script from "./TenantSubscriptionExtendPeriodDialog.vue?vue&type=script&lang=js&"
export * from "./TenantSubscriptionExtendPeriodDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports